import { TTypeOfErrorModalWindow, TTypeOfModalWindow } from './styleSettingsCarouselUploaderContext';

export enum StyleSettingsCarouselUploaderActionTypes {
	SET_CROPPER_SRC = 'SET_CROPPER_SRC',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_TYPE_OF_ERROR_MODAL_WINDOW = 'CHANGE_TYPE_OF_ERROR_MODAL_WINDOW',
}

interface ISetCropperSrc {
	type: StyleSettingsCarouselUploaderActionTypes.SET_CROPPER_SRC;
	payload: {
		src: string | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeTypeOfErrorModalWindow {
	type: StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW;
	payload: {
		typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	};
}

export type TStyleSettingsCarouselUploaderAction =
	| ISetCropperSrc
	| IChangeTypeOfModalWindow
	| IChangeTypeOfErrorModalWindow;
